export default function apiUrl() {
  let apiLink;
  if (
    window.location.hostname === "qaweb.samsung.com" ||
    window.location.hostname === "aem-eu.samsung.com"
  ) {
    apiLink = window.location.origin;
  } else if (window.location.hostname === "www.samsung.com") {
    apiLink = window.location.origin;
  } else if (window.location.hostname === "localhost") {
    apiLink = "http://localhost/mwp-dash/";
  } else {
    apiLink = window.location.origin;
  }
  return apiLink;
}